module.exports = __webpack_public_path__ + "static/img/image.11b625a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid/image.png
// module id = Ypl4
// module chunks = 3